import {
  SET_LOCK_SWITCH_RECORDS,
  SET_LOCK_REPLACE_RECORDS,
} from '../constants/LockRecordConstants';

const initialState = {
  switchDatas: {
    list: [],
    count: 0,
  },
  replaceDatas: {
    list: [],
    count: 0,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_LOCK_SWITCH_RECORDS: {
      return {
        ...state,
        switchDatas: {
          list: action.payload.list,
          count: action.payload.count,
        },
      };
    }

    case SET_LOCK_REPLACE_RECORDS: {
      return {
        ...state,
        replaceDatas: {
          list: action.payload.list,
          count: action.payload.count,
        },
      };
    }

    default: {
      return state;
    }
  }
}
